import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'

export const togglePermalink = createActionCreator(actions.TOGGLE_PERMALINK)



// WEBPACK FOOTER //
// ./src/actionCreators/showPermalink.js